import { RouteObject } from '@suntex.core/nav'
import { EntityLevel } from '@suntex.fim/enums'
import { RequireAuth } from '@suntex.fim/framework'
import { SchoolLayout } from '@suntex.fim/nav'

import AssessmentReportLayout from '../pages/app/AssessmentReport/AssessmentReportLayout'
import Dashboard from '../pages/app/Dashboard'
import AssignTeachers from '../pages/app/SchoolManagement/AssignTeachers'
import BasicInformation from '../pages/app/SchoolManagement/BasicInformation'
import ManageStaff from '../pages/app/SchoolManagement/ManageStaff'
import PlayerManagement from '../pages/app/SchoolManagement/PlayerManagement'
import ViewEditTeams from '../pages/app/SchoolManagement/ViewEditTeams'
import SchoolMovePlayers from '../pages/app/TeamManagement/SchoolMovePlayers'
import TeamPrintLogins from '../pages/app/TeamManagement/TeamPrintLogins'

import { layoutChrome } from './navChrome'
import { getRankingRoutes } from './rankingsRoutes'
import { getAssessmentReportRoutes, getCommonRoutes } from './routeHelpers'

export const schoolRoutes: RouteObject[] = [
  {
    path: '/school/:schoolId',
    element: <RequireAuth />,
    children: [
      {
        element: <SchoolLayout {...layoutChrome} />,
        children: [
          {
            path: 'dashboard',
            Component: Dashboard
          },
          {
            path: 'assessment-report',
            Component: AssessmentReportLayout,
            children: getAssessmentReportRoutes(EntityLevel.School)
          },
          ...getCommonRoutes(EntityLevel.School),
          ...getRankingRoutes(EntityLevel.School),
          {
            path: 'school-management/basic-information',
            Component: BasicInformation
          },
          {
            path: 'school-management/manage-staff',
            Component: ManageStaff
          },
          {
            path: 'school-management/assign-teachers',
            Component: AssignTeachers
          },
          {
            path: 'school-management/view-edit-teams',
            Component: ViewEditTeams
          },
          {
            path: 'school-management/player-management',
            Component: PlayerManagement
          },
          {
            path: 'school-management/move-players',
            Component: SchoolMovePlayers
          },
          {
            path: 'school-management/print-logins',
            Component: TeamPrintLogins
          }
        ]
      }
    ]
  }
]
